import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-document-slot',
  templateUrl: './document-slot.component.html',
  styleUrls: ['./document-slot.component.css'],
})
export class DocumentSlotComponent {
  @Input() label = '';
  @Input() numero = 0;
  @Input() files: any[] = [];
  @Input() accept = 'image/*,application/pdf,.doc,.docx';
  @Input() maxFiles = 2;
  @Input() progress = 0;
  @Input() uploading = false;
  @Input() disabled = false;
  @Input() required = false;
  @Input() searchTerm = '';

  @Output() filesAdded = new EventEmitter<FileList | File[]>();
  @Output() fileRemoved = new EventEmitter<number>();

  get inputId(): string {
    return 'doc-slot-' + this.numero;
  }

  get atCapacity(): boolean {
    return this.files.length >= this.maxFiles;
  }

  get visible(): boolean {
    if (!this.searchTerm) {
      return true;
    }
    const needle = this.searchTerm.trim().toLowerCase();
    if (!needle) {
      return true;
    }
    return (this.label || '').toLowerCase().includes(needle);
  }

  onDrop(files: FileList): void {
    if (this.disabled || this.atCapacity || !files || !files.length) {
      return;
    }
    this.filesAdded.emit(files);
  }

  onBrowse(input: HTMLInputElement): void {
    if (this.disabled || this.atCapacity || !input.files || !input.files.length) {
      input.value = '';
      return;
    }
    this.filesAdded.emit(input.files);
    input.value = '';
  }

  onRemove(index: number): void {
    if (this.disabled) {
      return;
    }
    this.fileRemoved.emit(index);
  }

  formatBytes(bytes: number): string {
    if (!bytes) {
      return '0 B';
    }
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }
}
